// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1e-Pd","title":"styles_title__21Ouz"};